module.exports = __webpack_public_path__ + "media/images/icons/country_flags/hm-d7f4f6208ebc8b2a936b200726059a71.svg";